import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from "../../../../../dynamicFormBuilder/FormField";
import { PrimaryLayout } from "../Layout";

// Primary tab of the WM Item Kit Data Profile form (Delphi WMD0103). Holds the profile block and the
// User Defined Codes block; the codes are WMCODES lookups configured in Layout.js, so no client-side
// option loading is needed here.
function PrimaryTab(props) {
    const currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const handleSelectionChange = useCallback((name, value, e) => {
        if (props.handleFieldChange) props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId="0103b2c6-9d41-4e78-8b52-0103ddeeff11"
                layoutName="WMItemKitProfilePrimaryForm"
                defaultFormSchema={PrimaryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(PrimaryTab);
